<template>
  <div class="has-logo">
    <sidebar-logo :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in routers"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SidebarLogo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "../../../assets/styles/variables.scss";

export default {
  name: "Sidebar",
  components: {
    SidebarLogo,
    SidebarItem,
  },
  computed: {
    ...mapState({
      opened: (state) => state.sidebar.opened,
    }),
    routers() {
      return this.$router.options.routes.filter((r) => r.layout === "root");
    },
    activeMenu() {
      const route = this.$route;
      const { path } = route;
      const selectedMenu = this.routers.find((r) => {
        if (r.path === "/") {
          return path === "/";
        }
        return path.includes(r.path);
      });
      return selectedMenu.path;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.opened;
    },
  },
};
</script>

<style lang="scss" scoped></style>
